/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";

// import StatusCustom from "../../components/status/StatusCustom";
import { type NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import { saveAs } from "file-saver";
import { checkPermission, permission_config } from "../../../../utils/app.utils";
import { EmployeesCMSApi } from "../../../../api/employee-cms/employee.api";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import { routeName } from "../../../../routes/routeName";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { PositionApi } from "../../../../api/position/position.api";
import { alertActive, alertSuccess } from "../../../../components/alert/swal";
import { RootState } from "../../../../store/store";

const manageState = ({ code }: { code: string }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    // const maxWidthScreen = useMediaQuery('(min-width:1920px)');
    const navigate: NavigateFunction = useNavigate();
    // const currentLanguage = i18n.language;
    const profile = useSelector((state: RootState) => state.profile.profile) as any;

    // const profileReducer = useSelector((state: any) => state.profile.value);
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission("WEBSITE_STRUCTURE_EMPLOYEE", permission)

    // console.log(profileReducer, profile);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [remaining_days, set_remaining_days] = useState<string>("");
    const [position, set_position] = useState<string>("");
    const [department, set_department] = useState<string>("");
    const [id_department, set_id_department] = useState<any>(null);
    const [startDate, setStartDate] = useState<string | null>("");
    const [endDate, setEndDate] = useState<string | null>("");
    const [data, setData] = useState<any[]>([]);
    const [positionList, setPositionList] = useState<any[]>([]);
    const [companyList, setCompanyList] = useState<any[]>([]);
    const [departmentList, setDepartmentList] = useState<any[]>([]);
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const handleChangeDateRange = (st_date: string | null, end_date: string | null) => {
        setStartDate(st_date)
        setEndDate(end_date)
    }

    const headCell = [
        {
            id: "employee_no", width: 200, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "employee_name", disablePadding: false, width: 240, sortable: true, align: "center", label: t("ชื่อ-นามสกุล")
        },
        {
            id: "position_name", disablePadding: false, align: "center", width: 250, label: t("อีเมล")
        },
        {
            id: "department_name", disablePadding: false, align: "center", width: 257, label: t("เบอร์โทรศัพท์")
        },
        {
            id: "department_name", disablePadding: false, align: "center", width: 257, label: t("บทบาท")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 257, label: t("สถานะการใช้งาน")
        },
        {
            id: "emp_last_modified_by", disablePadding: false, align: "center", width: 150, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "emp_last_modified_date", disablePadding: false, align: "center", width: 257, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "center", class: matches, className: "ml-10", width: 140, label: ""
        },
    ];

    const renderDate = (date: string) => {
        return moment(date).add('year', 543).format("DD/MM/YYYY")
    }

    const handleSwitchChange = (id_employee: number, isActive: boolean) => {
        const updatedStatus = isActive ? "active" : "inactive";
        EmployeesCMSApi.updateEmployee(id_employee, { status: updatedStatus })
            .then((res) => {
                if (res.status < 300) {
                    handleGetDataList();
                }
            })
            .catch((err) => {
                console.error("Error updating employee status:", err);
            });
    };

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            id_employee,
            employee_full_name,
            // email_personal,
            email_organization,
            phone_number,
            roles_name,
            status,
            modified_name,
            created_date,
            create_name,
            modified_date,
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { id: "employee_no", option: "TEXT", align: "center", label: no || "-" },
                {
                    id: "employee_name",
                    option: "TEXT",
                    align: "left",
                    label: employee_full_name || '',
                    // label: employee_name || "" + " " + employee_last_name || "",
                },
                {
                    id: "position_name",
                    option: "TEXT",
                    align: "left",
                    disablePadding: true,
                    label: email_organization || "-"
                },
                {
                    id: "department_name",
                    option: "TEXT",
                    align: "center",
                    label: phone_number || "-"
                },
                {
                    id: "sd",
                    option: "TEXT",
                    align: "center",
                    label: roles_name || "-"
                },
                {
                    id: "status",
                    option: "COMPONENT",
                    align: "center",
                    component: <div className="justify-self-center">
                        <SwitchCustom
                            disabled={!checkPermit.isUpdate}
                            checked={status == "active"}
                            onChange={(s) => {
                                handleSwitchChange(id_employee, s);
                            }}
                        />
                    </div>
                },
                {
                    id: "emp_last_modified_by",
                    option: "TEXT",
                    align: "center",
                    label: modified_name ? modified_name : create_name || "-",
                },
                {
                    id: "emp_last_modified_date",
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? renderDate(modified_date) : created_date ? renderDate(created_date) : "-"
                },
                {
                    id: "action",
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component:
                        <div className="flex justify-between items-center">
                            {/* <StatusCustom sx={{ maxWidth: 180 }}
                                text={renderStepTextStatus(current_step)}
                                type={renderStepTextStatus(current_step)}
                            /> */}
                            <OptionsButtonCustom
                                // enableView
                                // enableDelete
                                // enableEdit
                                enableView={checkPermit.isView}
                                enableDelete={checkPermit.isDelete}
                                enableEdit={checkPermit.isUpdate}
                                onViewClick={() => {
                                    navigate(routeName.cms_website.employeeView.replace(":id", id_employee.toString()))
                                }}
                                onEditClick={() => {
                                    navigate(routeName.cms_website.employeeDetail.replace(":id", id_employee.toString()))
                                }}
                                onDeleteClick={() => handleDeleteEmployeeById(id_employee)}
                            />
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const renderPositionOptions = (): { label: string, value: string }[] => {
        const rs = [{ label: t("EMP.ALL_POSITION"), value: "ALL" }]
        if (positionList.length > 0) {
            const list: any[] = positionList
            for (const pos of list) {
                rs.push({ label: pos.position_name, value: pos.id_position?.toString() || "" })
            }
        }
        return rs
    }

    const renderDepartmentOptions = (): { label: string, value: string }[] => {
        const rs = [{ label: t("EMP.ALL_DEPARTMENT"), value: "ALL" }]
        if (departmentList.length > 0) {
            const list: any[] = departmentList
            for (const dep of list) {
                rs.push({ label: dep.department_name, value: dep.id_department?.toString() || "" })
            }
        }
        return rs
    }

    const handleGetDataList = useCallback(async () => {
        let params: any = {
            limit: pageLimit,
            page: page,
            sortType: sortType,
            sortBy: sortBy
        }
        if (search) params = { ...params, keyword: search }
        if (position) params = { ...params, id_position: +position }
        // if (department) params = { ...params, id_department: +department }
        if (id_department) params = { ...params, id_department: id_department?.id_department }
        if (!search) {
            dispatch(setLoading());
        }
        if (startDate && endDate) params = {
            ...params,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            start_date: moment(startDate).format("YYYY-MM-DD"),
        }
        await EmployeesCMSApi.getEmployeeList(params).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            if (search) {
                setTimeout(() => {
                    dispatch(unsetLoading());
                }, 400)
            } else {
                dispatch(unsetLoading());
            }
            // unLoading()
        })
    }, [pageLimit, page, sortType, sortBy, search, position, id_department, startDate, endDate])


    // const handleImportExcel = async (file: any) => {
    //     dispatch(setLoading());
    //     const form_data = new FormData();
    //     form_data.append('file', file);
    //     await EmployeeReportsApi.import(form_data).then((res) => {
    //         if (res.status < 300) {
    //             const is_valid_data: { index: string, msg: string }[] = res.data?.data || []
    //             if (is_valid_data.length > 0) {
    //                 alertSuccess("อัพโหลดข้อมูลเสร็จสิ้น", `มีบางรายการเกิดข้อผิดพลาด ,${is_valid_data.map((x, i) => `${i === 0 ? "ข้อมูลลำดับที่" : ""} ${x.index + ": "}${x.msg}`)}`, undefined, undefined, undefined, true);
    //             } else {
    //                 alertSuccess("อัพโหลดข้อมูล", `อัพโหลดข้อมูล สำเร็จ`);
    //             }
    //             handleGetDataList();
    //         }
    //     }).catch((err) => {
    //         alertError("อัพโหลดข้อมูล", "อัพโหลดข้อมูลไม่สำเร็จ")
    //         console.log(err)
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    // const handleExportExcel = async () => {
    //     dispatch(setLoading());
    //     await EmployeeReportsApi.export().then((res) => {
    //         if (res.status < 300) {
    //             const data = res.data;
    //             const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    //             saveAs(blob, `ข้อมูลพนักงาน-วันที่${moment().format("DD/MM/YYY")}-เวลา-${moment().format("HH:mm")}`);
    //         }
    //     }).catch((err) => {
    //         alertError("ดาวน์โหลด", "ดาวน์โหลดข้อมูลไม่สำเร็จ")
    //         console.log(err)
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }

    useEffect(() => {
        handleGetDataList();
        // handleGetPositionDataList();
        // handleGetDepartmentDataList();
        // handleGetCompanyDataList()
    }, [handleGetDataList])

    // const handleGetPositionDataList = async () => {
    //     await PositionApi.master().then((res) => {
    //         if (res.status < 300) {
    //             setPositionList(res.data.data || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }

    // const handleGetDepartmentDataList = async () => {
    //     await DepartmentApi.master().then((res) => {
    //         if (res.status < 300) {
    //             setDepartmentList(res.data.data || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }
    // const handleGetCompanyDataList = async () => {
    //     await CompanyApi.master().then((res) => {
    //         if (res.status < 300) {
    //             setCompanyList(res.data.data || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }

    const handleDeleteEmployeeById = async (id_employee: number) => {
        alertActive("ลบข้อมูลพนักงาน", "ต้องการลบข้อมูลพนักงานนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await EmployeesCMSApi.deleteEmployee(id_employee).then((res) => {
                if (res.status < 300) {
                    handleGetDataList();
                    alertSuccess("ลบข้อมูลพนักงาน", "ลบข้อมูลพนักงาน เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    // const handlePullEmployeeData = async () => {
    //     alertActive("ดึงข้อมูลพนักงาน", "ต้องการดึงข้อมูลพนักงานจาก SAP หรือไม่?", undefined, undefined, async () => {
    //         dispatch(setLoading());
    //         await EmployeesCMSApi.pullEmployeeDataDepartment().then(async (res) => {
    //             if (res.status < 300) {
    //                 await EmployeesApi.pullEmployeeDataPosition().then(async (res) => {
    //                     if (res.status < 300) {
    //                         await EmployeesApi.pullEmployeeData().then((res) => {
    //                             if (res.status < 300) {
    //                                 handleGetDataList();
    //                                 alertSuccess("ดึงข้อมูลพนักงาน", "ดึงข้อมูลพนักงาน เรียบร้อย");
    //                             }
    //                         }).catch(() => alertError("ดึงข้อมูลพนักงาน", 'ดึงข้อมูลพนักงาน ไม่สำเร็จ')).finally(() => {
    //                             dispatch(unsetLoading());
    //                         })
    //                     }
    //                 }).catch(() => alertError("ดึงข้อมูลพนักงาน", 'ดึงข้อมูลพนักงาน ไม่สำเร็จ')).finally(() => {
    //                     dispatch(unsetLoading());
    //                 })
    //             }
    //         }).catch((err) => {
    //             alertError("ดึงข้อมูลพนักงาน", 'ดึงข้อมูลพนักงาน ไม่สำเร็จ')
    //             console.log(err)
    //         }).finally(() => {
    //             dispatch(unsetLoading());
    //         })
    //     })
    // }

    return {
        renderData,
        page,
        pageLimit,
        sortBy,
        sortType,
        headCell,
        totalItems,
        data,
        handleRequestSort,
        setPageLimit,
        setPage,
        setSearch,
        setEndDate,
        endDate,
        remaining_days,
        set_remaining_days,
        position,
        set_position,
        department,
        set_department,
        renderPositionOptions,
        renderDepartmentOptions,
        // handlePullEmployeeData,
        // handleImportExcel,
        // handleExportExcel,
        positionList,
        departmentList,
        companyList,
        set_id_department,
        id_department,
        checkPermit,
        handleChangeDateRange,
        startDate,
    }
}

export default manageState